import ArneRust from 'innovate/assets/images/StakeHolders/ArneRust-modified.png';
import AmyDing from 'innovate/assets/images/StakeHolders/AmyDing.jpg';
import dayanne_img from 'innovate/assets/images/StakeHolders/DAYANNE_PENAGOS.jpg';
import sharon_img from 'innovate/assets/images/StakeHolders/Sharon_palmer.jpg';
import GabrielaGallo from 'innovate/assets/images/StakeHolders/GabrielaGallo.jpeg';
import world1 from 'innovate/World2.json';
import React, { useEffect, useState } from 'react';
import { ComposableMap, Geographies, Geography, Marker } from 'react-simple-maps';
import { FaUser } from 'react-icons/fa';

interface GeoJson {
  type: string;
  features: {
    type: string;
    properties: {
      NAME: string;
    };
    geometry: {
      type: string;
      coordinates: number[][][][];
    };
  }[];
}

interface CountryData {
  countryName: string;
  name: string;
  position: string;
  coordinates: [number, number];
}

const world = world1 as GeoJson;

const STAKEHOLDER_IMAGES: Record<string, string> = {
  Brazil: GabrielaGallo,
  'South Africa': ArneRust,
  Mexico: dayanne_img,
  'United Kingdom': sharon_img,
  China: AmyDing,
};

const GEOGRAPHY_STYLE = {
  default: { fill: '#5B5B5B', outline: 'none', stroke: '#5B5B5B', strokeWidth: 0.75 },
  hover: { fill: '#5B5B5B', outline: 'none', stroke: '#5B5B5B', strokeWidth: 0.75 },
  pressed: { fill: '#5B5B5B', outline: 'none', stroke: '#5B5B5B', strokeWidth: 0.75 },
};

const ApicountryData: CountryData[] = [
  {
    countryName: 'Brazil',
    name: 'Gabriela Gallo',
    position: 'BRAND MANAGEMENT DIRECTOR I',
    coordinates: [-55.491977, -10.836389],
  },
  {
    countryName: 'South Africa',
    name: 'Arné Rust',
    position: 'INNOVATIONS DIRECTOR',
    coordinates: [25.083901, -29.000341],
  },
  {
    countryName: 'Mexico',
    name: 'Dayanne Penagos Quintero',
    position: 'INNOVATIONS DIRECTOR',
    coordinates: [-102.552784, 23.634501],
  },
  {
    countryName: 'United Kingdom',
    name: 'Sharon Palmer',
    position: 'HEAD OF INNOVATIONS BU WEST & CENTRAL',
    coordinates: [-3.435973, 55.378051],
  },
  {
    countryName: 'China',
    name: 'Amy Ding',
    position: 'INNOVATION SR. DIRECTOR',
    coordinates: [114.0579, 22.5431],
  },
];

const calculateCentroid = (coordinates: number[][][][]): [number, number] => {
  let totalX = 0;
  let totalY = 0;
  let totalPoints = 0;

  coordinates.forEach((polygon) => {
    polygon.forEach((ring) => {
      ring.forEach((point) => {
        if (point?.[0] !== undefined && point?.[1] !== undefined) {
          totalX += point[0];
          totalY += point[1];
          totalPoints += 1;
        }
      });
    });
  });

  return [totalX / totalPoints, totalY / totalPoints];
};

const StakeholderAvatar: React.FC<{ countryName: string }> = ({ countryName }) => {
  const imageUrl = STAKEHOLDER_IMAGES[countryName];

  return (
    <>
      <circle cx="14" cy="12" r="22" fill="#F1D513" stroke="#FFFFFF" strokeWidth="2" />
      {imageUrl ? (
        <image href={imageUrl} width="40" height="40" x="-6" y="-8" clipPath="url(#circularClip)" />
      ) : (
        <foreignObject x="-6" y="-8" width="40" height="40">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <FaUser size={24} color="#FFFFFF" />
          </div>
        </foreignObject>
      )}
    </>
  );
};

const WorldMap: React.FC = () => {
  const [countryData, setCountryData] = useState<CountryData[]>([]);

  useEffect(() => {
    const newCountryData: CountryData[] = ApicountryData.map((data) => {
      const feature = world.features.find((item) => item.properties.NAME === data.countryName);
      if (!feature) return null;

      const centroid = calculateCentroid(feature.geometry.coordinates);

      return {
        countryName: feature.properties.NAME,
        coordinates: centroid,
        name: data.name,
        position: data.position,
      };
    }).filter((data) => data !== null) as CountryData[];

    setCountryData(newCountryData);
  }, []);

  return (
    <ComposableMap
      projectionConfig={{ rotate: [-11, 0, 0], scale: 205 }}
      height={551}
      style={{ height: 'auto', width: '100%' }}
      width={980}
    >
      <defs>
        <clipPath id="circularClip">
          <circle cx="14" cy="12" r="20" />
        </clipPath>
      </defs>

      <Geographies geography={world1}>
        {({ geographies }) =>
          geographies.map((geography) => (
            <Geography
              key={geography.properties.NAME}
              geography={geography}
              style={GEOGRAPHY_STYLE}
            />
          ))
        }
      </Geographies>

      {countryData.map((data) => (
        <Marker key={data.name} coordinates={data.coordinates} fill="#777">
          <>
            <text textAnchor="start" fill="#FFFFFF" dy={2} dx={40} fontSize="14px" fontWeight={700}>
              {data.name}
            </text>
            <text
              textAnchor="start"
              fill="#F1D513"
              dy={20}
              dx={40}
              fontSize="12.4px"
              fontWeight={600}
            >
              {data.countryName === 'Mexico' ? 'MAZ' : data.countryName}
            </text>
            <text
              textAnchor="start"
              fill="#FFFFFF99"
              dy={34}
              dx={40}
              fontSize="10.4px"
              fontWeight={600}
            >
              {data.position}
            </text>
            <StakeholderAvatar countryName={data.countryName} />
          </>
        </Marker>
      ))}
    </ComposableMap>
  );
};

export default WorldMap;
